<template>
    <div class="page">
        正在加载中...
    </div>
</template>
<script>
import { ApiLoginBySecret } from '@/common/api';
import actions from '@/common/store';
export default {
    name: 'freeLogin',
    data() {
        return {
            tenantList: [], // 当前用户的租户类型列表
            tmpToken: '', // 当前用户临时token，用户盘点需不需要跳转到租户选择界面
            tenantType: '' // 当前的租户类型
        };
    },
    created() {
        const secret = this.$route.query.secret;
        if (secret) {
            this.loginBySecret(secret);
        } else {
            this.pageTo();
        }
    },
    methods: {
        // 缓存用户信息
        setUserInfo(data) {
            this.$store.dispatch('set_token', data.token);
            const { tenantList, tmpToken, tenantType } = data;
            this.tenantType = tenantType;
            // 如果有tmpToken的话，需要先进入到选择租户的流程
            this.tenantType = tenantType;
            if (tmpToken) {
                this.tenantList = tenantList;
                this.tmpToken = tmpToken;
            } else {
                // 设置预制属性
                this.$analysys.registerSuperProperties({
                    application_name:
                        data.tenantType === 3 ? '阿基米德' : '梦饷云'
                });
                // 上报用户的浏览器信息
                this.$analysys.track('$startup', {});
            }
        },

        // 登录之后页面跳转
        pageTo() {
            // 梦饷云用户才跳转到小程序创建页
            if (this.tenantType === 2) {
                this.$router.push({
                    path: '/any/merchant/shop/mini-manage'
                });
            } else {
                this.$router.push({
                    path: '/any'
                });
            }
        },

        // 密钥登录
        loginBySecret(secret) {
            ApiLoginBySecret({ secret }).then(res => {
                const { data, message } = res;
                if (data) {
                    this.setUserInfo(data);
                    this.$message({
                        message,
                        duration: 1000,
                        type: 'success'
                    });
                    this.pageTo();
                } else {
                    this.$message.error({
                        message: '登录出错，请重试！',
                        duration: 2000
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.page {
    width: 100%;
    height: 100%;
    line-height: 90px;
    text-align: center;
}
</style>
